import React, { useState, useEffect } from 'react'
import Loader from '../../../../../../presentationals/Loader/Loader.component';
import PiePage from '../../../CommonComponents/PiePage.component'
import InputField from '../../../CommonComponents/InputMUI'
import SelectField from '../../../CommonComponents/SelectMUI';
import { SaveUpdateOEMDetails } from '../../../Community/CommunityActionCreator';

const DifferenceInYear = 40;

const getYearValues = () => {
    const arr = [];
    const d = new Date();
    const currentYear = d.getFullYear();
    const PrevYear = currentYear - DifferenceInYear;


    for (let i = PrevYear; i <= currentYear; i++) {
        let obj = { name: i, code: i };
        arr.push(obj)
    }
    return arr

}

export default function OEMAddEdit({ handlePage,handleTab, Editdata }) {
    const [loader, setLoader] = useState(false)
    const [responseMsg, setResponseMsg] = useState("")
    const [yearData, setYearData] = useState(getYearValues())
    const [errors, setErrors] = useState({});
    const [objectDataNew, setobjectDataNew] = useState({
        model: "",
        make: "",
        makeClass: "",
        vehicleType: "",
        variant: "",
        year: "",
    })

    useEffect(() => {
        if (Editdata?.id) {
            setobjectDataNew({
                model: Editdata.model,
                make: Editdata.make,
                makeClass: Editdata.makeClass,
                vehicleType: Editdata.vehicleType,
                variant: Editdata.variant,
                year: Editdata.year,
            })
        } else {
            setobjectDataNew({
                model: "",
                make: "",
                makeClass: "",
                vehicleType: "",
                variant: "",
                year: "",
            })
        }
    }, [Editdata])

    const inputChange = (e, type) => {
        setobjectDataNew((prev) => ({
            ...prev,
            [type]: e
        }))
    }

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        if (!objectDataNew.model) {
            formErrors.model = "Model is required";
            isValid = false;
        }

        if (!objectDataNew.make) {
            formErrors.make = "Vehicle Make is required";
            isValid = false;
        }
        if (!objectDataNew.makeClass) {
            formErrors.makeClass = "Vehicle Make Class is required";
            isValid = false;
        }
        if (!objectDataNew.vehicleType) {
            formErrors.vehicleType = "Vehicle Type is required";
            isValid = false;
        }
        if (!objectDataNew.variant) {
            formErrors.variant = "Vehicle Variant is required";
            isValid = false;
        }
        if (!objectDataNew.year) {
            formErrors.year = "Year is required";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const saveHandler = (type) => {
        if (type === "close") {
            setobjectDataNew({
                model: "",
                make: "",
                makeClass: "",
                vehicleType: "",
                variant: "",
                year: "",
            })
            handleTab("list", "")
        } else {
            if (validateForm()) {
                setLoader(true)
                SaveUpdateOEMDetails(objectDataNew, (callback) => {
                    setLoader(false)
                    console.log("call", callback)
                    if(callback && callback?.message == "success" && callback?.status == 200){
                        handlePage("OEMBre", objectDataNew)
                    }else{
                        setResponseMsg("Error: Please try again later!")
                    }
                })
             
            }
            RemoveErrors()
        }
    }

    const RemoveErrors = ()=>{
        setTimeout(()=>{
            setErrors({})
        },3000)
    }

    return (
        <div className="communitySection">
            <div className='container hoverNone card'>
                {loader ?
                    <Loader />
                    : null}


                <PiePage
                    totalPage={2}
                    currentPage={1}
                    heading={'Add Vehicle OEM Details'}
                />

                <div className='row' style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Model"
                            variant="outlined"
                            value={objectDataNew.model}
                            name="model"
                            id="model"
                            type="text"
                            onChange={e => inputChange(e, 'model')}
                            size="small"

                        />

                        {errors.model && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.model}</span>
                        )}

                    
                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Vehicle Make"
                            variant="outlined"
                            value={objectDataNew.make}
                            name="make"
                            id="make"
                            type="text"
                            onChange={e => inputChange(e, 'make')}
                            size="small"



                        />
                        {errors.make && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.make}</span>
                        )}

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Vehicle Make Class"
                            variant="outlined"
                            value={objectDataNew.makeClass}
                            name="makeClass"
                            id="makeClass"
                            type="text"
                            onChange={e => inputChange(e, 'makeClass')}
                            size="small"


                        />
                         {errors.makeClass && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.makeClass}</span>
                        )}

                    </div>
                </div>
                <div className='row' style={{ marginBottom: '12px' }}>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Vehicle Type"
                            variant="outlined"
                            value={objectDataNew.vehicleType}
                            name="vehicleType"
                            id="vehicleType"
                            type="text"
                            onChange={e => inputChange(e, 'vehicleType')}
                            size="small"
                            // required={true}
                            inputProps={{ maxLength: 12 }}

                        />
                      {errors.vehicleType && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.vehicleType}</span>
                        )}


                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Vehicle Variant"
                            variant="outlined"
                            value={objectDataNew.variant}
                            name="variant"
                            id="variant"
                            type="text"
                            onChange={e => inputChange(e, 'variant')}
                            size="small"
                        // required={true}
                        />
 {errors.variant && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.variant}</span>
                        )}
                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        {/* <InputField
                            label="Year"
                            variant="outlined"
                            value={objectDataNew.year}
                            name="year"
                            id="year"
                            type="year"
                            onChange={e => inputChange(e, 'year')}
                            size="small"
                        /> */}
                        <SelectField
                            value={objectDataNew.year}
                            label="Year"
                            onChange={e => inputChange(e, 'year')}
                            name="year"
                            id="year"
                            data={yearData}
                            size={'small'}

                        />
                        {errors.year && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.year}</span>
                        )}

                    </div>
                </div>

                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>
                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save & Continue</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
